/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { AuditLog, AuditLog$inboundSchema } from "./auditlog.js";

export type ListAuditLogsResult = {
  /**
   * List of audit logs
   */
  logs: Array<AuditLog>;
  /**
   * The cursor to be used for the next page of results.
   */
  nextCursor?: string | undefined;
};

/** @internal */
export const ListAuditLogsResult$inboundSchema: z.ZodMiniType<
  ListAuditLogsResult,
  unknown
> = z.pipe(
  z.object({
    logs: z.array(AuditLog$inboundSchema),
    next_cursor: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function listAuditLogsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListAuditLogsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListAuditLogsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListAuditLogsResult' from JSON`,
  );
}
